import React, { useState, useEffect } from "react";
import { apiRequest } from "../utils/api";
import ProductSearchMail from "../components/ProductSearchMail";
import { useAlert } from '../components/AlertModal';
import "../styles/EmailComposeModal.css";


const EmailComposeModal = ({
  isOpen,
  onClose,
  to,
  subject,
  body,
  storeId,
  draftId,
  setDraftId,
  originalMailId,
  onRemoveDraft,
}) => {
  const [emailTo, setEmailTo] = useState(to || "");
  const [emailSubject, setEmailSubject] = useState(subject || "");
  const [emailBody, setEmailBody] = useState(body || "");
  const [sending, setSending] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [originalBody, setOriginalBody] = useState("");
  const { showAlert, showConfirm } = useAlert();

  useEffect(() => {
    if (originalMailId) {
      apiRequest(`inventory/mail/received/${originalMailId}/`)
        .then((res) => setOriginalBody(res.body))
        .catch((err) => console.warn("元メールの読み込み失敗", err));
    }
  }, [originalMailId]);

  useEffect(() => {
    const fetchDraft = async () => {
      if (draftId) {
        try {
          const res = await apiRequest(`inventory/email_drafts/${draftId}/`);
          setEmailTo(res.to);
          setEmailSubject(res.subject);
          setEmailBody(res.body);
          if (res.original_mail?.body) {
            setOriginalBody(res.original_mail.body);
          }
        } catch (err) {
          console.error("下書き取得に失敗", err);
        }
      } else {
        // draftId が無ければ初期値を使用（新規作成）
        setEmailTo(to);
        setEmailSubject(subject);
        setEmailBody(body);
      }
    };

  fetchDraft();
}, [draftId, to, subject, body]);

  if (!isOpen) return null;

  const extractEmailAddress = (value) => {
    const match = value.match(/<(.*?)>/);
    return match ? match[1] : value;
  };

  const handleSend = async () => {
    setSending(true);
    try {
      await apiRequest("inventory/mail/send/", "POST", {
        to_address: extractEmailAddress(emailTo),
        subject: emailSubject,
        body: emailBody,
      });

    // 下書きが存在する場合は削除する
    if (draftId) {
      try {
        await apiRequest(`inventory/email_drafts/${draftId}/`, "DELETE");
        if (onRemoveDraft) onRemoveDraft(draftId);
        setDraftId(null);
        console.log("送信後に下書きを削除しました");
      } catch (deleteErr) {
        console.warn("送信後の下書き削除に失敗", deleteErr);
      }
    }
      showAlert("メールを送信しました。");
      onClose();
    } catch (err) {
      showAlert("メール送信に失敗しました。");
      console.error(err);
    } finally {
      setSending(false);
    }
  };

  const handleSaveDraft = async () => {
    const payload = {
      to: extractEmailAddress(emailTo),
      subject: emailSubject,
      body: emailBody,
      ...(originalMailId && { original_mail_id: originalMailId }),
    };

    try {
      const method = draftId ? "PATCH" : "POST";
      const endpoint = draftId
        ? `inventory/email_drafts/${draftId}/`
        : "inventory/email_drafts/";

      const response = await apiRequest(endpoint, method, payload);

      if (!draftId && response?.id) {
        // POST時に新しいIDを保存して以後は上書き対象に
        setDraftId(response.id);
      }

      showAlert("下書きを保存しました");
    } catch (err) {
      showAlert("下書き保存に失敗しました");
      console.error(err);
    }
  };

  return (
    <div className="email-modal-overlay">
      <div className="email-modal">
        {/* 左パネル：元メール本文 */}
        <div className="email-preview-panel EmailCompose-scrollArea">
          <h3>受信メール</h3>
          <pre className="email-original-body">
            {originalBody || "（受信メールなし）"}
          </pre>
        </div>

        {/* 中央パネル：送信編集 */}
        <div className="email-editor-panel EmailCompose-scrollArea">
          <h2>メール送信</h2>
          <label>宛先（To）</label>
          <input
            type="email"
            value={emailTo}
            onChange={(e) => setEmailTo(e.target.value)}
            disabled
          />
          <label>件名</label>
          <input
            type="text"
            value={emailSubject}
            onChange={(e) => setEmailSubject(e.target.value)}
          />
          <label>本文</label>
          <textarea
            className="email-textarea"
            rows="12"
            value={emailBody}
            onChange={(e) => setEmailBody(e.target.value)}
          />
          <div className="email-modal-actions">
            <button className="email-modal-actions-cancel-button" onClick={onClose}>
              キャンセル
            </button>
            <div className="email-modal-actions-buttons"> 
                <button onClick={handleSaveDraft}>💾 下書き保存</button>
              
              <button
                className="email-modal-actions-send-button"
                onClick={() => {
                  if (showConfirm("このメールを送信してもよろしいですか？")) {
                    handleSend();
                  }
                }}
                disabled={sending}
              >
                {sending ? "送信中…" : "送信"}
              </button>
            </div>
          </div>
        </div>

        {/* 右パネル：商品検索 */}
        <div className="email-side-panel">
          <ProductSearchMail
            storeId={storeId}
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            searchResults={searchResults}
            setSearchResults={setSearchResults}
          />
        </div>
      </div>
    </div>
  );
};

export default EmailComposeModal;
